import MuiTabContext, { getPanelId, getTabId, useTabContext, } from '@material-ui/lab/TabContext';
var RcTabContext = MuiTabContext;
RcTabContext.displayName = 'RcTabContext';
export { getPanelId, getTabId, RcTabContext, useTabContext };
